import { Easing, Tween } from '@tweenjs/tween.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import AnimateEntrance from '../helper/animate';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { COMPONENTS, EVENTS } from '../../lib/constants';

class FreespinWinController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency, true);
		this.win = 0;
		this.enabled = true;
		this.total_win = GameConfigs.freeSpinLocal.totalWin;

		this.vc = vc[this.config.holder];
		AnimateEntrance(this.vc.parent);

		this.WIN_TEXT = this.vc.FREE_SPIN_TOTAL_AMOUNT;
		this.BTN = this.vc.FREE_SPIN_BTN;

		this.init();
	}

	init() {
		this.BTN.handler = this.handler.bind(this);
		this.WIN_TEXT.alpha = 0;
		this.WIN_TEXT.scale.set(4);
		this.updateWin(this.total_win);
	}

	setWin() {
		this.WIN_TEXT.text = formatCurrencyValue(this.win, this.currency);
	}

	updateWin(a) {
		this.tweener = new Tween(this)
			.to({ win: a }, 600)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin();
			})
			.start();
		this.tweener = new Tween(this.WIN_TEXT.scale)
			.to({ x: 1, y: 1 }, 150)
			.easing(Easing.Linear.None)
			.delay(200)
			.start();
		this.tweener = new Tween(this.WIN_TEXT)
			.to({ alpha: 1 }, 300)
			.easing(Easing.Linear.None)
			.delay(200)
			.start();
	}

	handler() {
		if (this.enabled) {
			this.enabled = false;
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: '' });
			let obj = {
				...GameConfigs.freeSpinLocal,
				isFinished: true,
				started: false,
				status: ''
			};
			HELPERS.dispatchCustomEvent(EVENTS.FREESPIN, { freespin: obj });
			GameConfigs.freeSpinLocal = obj;
			GameConfigs.isFreeSpin = false;
			HELPERS.disableAllButtons(false);
			if (
				GameConfigs.uiComponent &&
				GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
			) {
				GameConfigs.uiComponent.removeView(
					GameConfigs.uiComponent[COMPONENTS.FREESPIN_STATUS_BAR]
				);
			}
		}
	}
}

export default FreespinWinController;
